import React from "react";
import ServicesCard from "./servicesCard";

const Services = () => {
  return (
    <div className="row text-center">
            <ServicesCard bgImgUrl={'assets/new-images/_MG_5623.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Digital skills training"} />

            <ServicesCard bgImgUrl={'assets/new-images/web-dev.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Web Development"} />

            <ServicesCard bgImgUrl={'assets/new-images/mobile.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Mobile App Development"} />

            <ServicesCard bgImgUrl={'assets/new-images/graphic-design.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Graphics designing"} />

            <ServicesCard bgImgUrl={'assets/new-images/consult.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Tech consulting"} />

            <ServicesCard bgImgUrl={'assets/new-images/socials.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Social Media Managment"} />

            <ServicesCard bgImgUrl={'assets/img/techex-landing-page/coworking.jpeg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Co-working spaces"} />

            <ServicesCard bgImgUrl={'assets/new-images/branding.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Branding"} />

            <ServicesCard bgImgUrl={'assets/new-images/literacy.jpg'} imgUrl={"assets/img/techex-landing-page/diagram.webp"} caption={"Digital Literacy"} />
        </div>
  );
}

export default Services;